module.exports = __webpack_public_path__ + "img/Emaar-1 1.ecfe0ad6.png";